import PropTypes from 'prop-types';
import React from "react";
import cx from "classnames";
import reactT from '../../components/reactT';

class FederatedPagination extends React.Component {

  onPageChange(page, pageAmt) {
    if (page >= pageAmt || page < 0) { return; }
    this.props.onChange(page);

    if(document.getElementById("stat") != null) {
      document.getElementById("stat").focus({preventScroll: false});
    }

    var element = document.querySelector('.solr-search-results');
    if (page >= 1) {
      element.classList.add('promoted-hidden');
    }
    else {
      element.classList.remove('promoted-hidden');
    }
  }

  buildHandleEnterKeyPress = (onClick) => ({ key }) => {
    if (key === 'Enter') {
      onClick();
    }
  };

  renderPage(page, currentPage, key) {
    let isCurrentPage = page === currentPage;
    return (
      <li className={cx("search-pager__item", (isCurrentPage ? 'is-active' : 'not-active'))} key={key} page={page + 1}>
        <div className={cx("search-pager__item-link search-pager__item-link--number")} role="button" tabIndex="0" onClick={this.onPageChange.bind(this, page)} onKeyPress={this.buildHandleEnterKeyPress(this.onPageChange.bind(this, page))} title={isCurrentPage ? "Current page" : `Go to page ${page + 1}`} aria-current={isCurrentPage ? page + 1 : undefined}>
          <span className="element-invisible">Page</span>{page + 1}
        </div>
      </li>
    );
  }

  render() {
    const { query, results } = this.props;
    const { start, rows } = query;
    var { numFound } = results;

    if (results.numFound === 'solrUnavailable') {
      numFound = 0;
    }

    const pageAmt = Math.ceil(numFound / rows);
    const currentPage = start / rows;
    const numButtons = this.props.options.paginationButtons || 5;

    let rangeStart = currentPage - 2 < 0 ? 0 : currentPage - 2;
    let rangeEnd = rangeStart + numButtons > pageAmt ? pageAmt : rangeStart + numButtons;

    if (rangeEnd - rangeStart < numButtons && rangeStart > 0) {
      rangeStart = rangeEnd - numButtons;
      if (rangeStart < 0) { rangeStart = 0; }
    }

    let pages = [];
    for (let page = rangeStart; page < rangeEnd; page++) {
      if (pages.indexOf(page) < 0) {
        pages.push(page);
      }
    }

    let firstPageHidden = (currentPage === 0);
    let prevPageHidden = (currentPage - 1 < 0);
    let nextPageHidden = (currentPage + 1 >= pageAmt);
    let lastPageHidden = (pageAmt === 0 || currentPage === pageAmt - 1);

    if (pages.length < 2) {
      return ('');
    }

    return (
      <nav className="search-pager" aria-labelledby="pagination-heading">
        <h4 id="pagination-heading" className="element-invisible">Pagination</h4>
        <ul className="search-pager__items justify-content-center">
          <li className={cx("search-pager__item search-pager__item--first", {"element-invisible": firstPageHidden})} key="start">
            <div className={cx("search-pager__item-link")} role="button" tabIndex={firstPageHidden ? "-1" : "0"} onClick={this.onPageChange.bind(this, 0)} onKeyPress={ this.buildHandleEnterKeyPress(this.onPageChange.bind(this, 0)) } title="Go to first page">
              <span className="page-first">{reactT('First')}</span>
            </div>
          </li>
          <li className={cx("search-pager__item search-pager__item--previous", {"element-invisible": prevPageHidden})} key="prev">
            <div className={cx("search-pager__item-link")} role="button" tabIndex={prevPageHidden ? "-1" : "0"} onClick={this.onPageChange.bind(this, currentPage - 1)} onKeyPress={ this.buildHandleEnterKeyPress(this.onPageChange.bind(this, currentPage - 1)) }title="Go to previous page" rel="next">
              <span className="page-previous">{reactT('Previous')}</span>
            </div>
          </li>
          {pages.map((page, idx) => this.renderPage(page, currentPage, idx))}
          <li className={cx("search-pager__item search-pager__item--next", {"element-invisible": nextPageHidden})} key="next">
            <div className={cx("search-pager__item-link")} role="button" tabIndex={nextPageHidden ? "-1" : "0"} onClick={this.onPageChange.bind(this, currentPage + 1, pageAmt)} onKeyPress={ this.buildHandleEnterKeyPress(this.onPageChange.bind(this, currentPage + 1, pageAmt)) } title="Go to next page" rel="next">
              <span className="page-next">{reactT('Next')}</span>
            </div>
          </li>
          <li className={cx("search-pager__item search-pager__item--last", {"element-invisible": lastPageHidden})} key="end">
            <div className={cx("search-pager__item-link")} role="button" tabIndex={lastPageHidden ? "-1" : "0"} onClick={this.onPageChange.bind(this, pageAmt - 1)} onKeyPress={ this.buildHandleEnterKeyPress(this.onPageChange.bind(this, pageAmt - 1)) } title="Go to last page">
              <span className="page-last">{reactT('Last')}</span>
            </div>
          </li>
        </ul>
      </nav>
    );
  }
}

FederatedPagination.propTypes = {
  onChange: PropTypes.func,
  query: PropTypes.object,
  results: PropTypes.object
};

export default FederatedPagination;
